export default "__VITE_ASSET__BvtyvflY__"